"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cleanToken = cleanToken;
function cleanToken(token) {
  return token.replaceAll(/bearer /gi, '');
}
